import React from "react";
import { Doughnut } from "react-chartjs-2";

const NationalityGroupCucleChart = ({ nationalityGroups }) => {
  // Extract data for the donut chart
  const chartData = {
    labels: nationalityGroups.map((group) => group.type ?? "Unknown"),
    datasets: [
      {
        data: nationalityGroups.map((group) => group.count),
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"],
      },
    ],
  };

  return (
    <div>
      <Doughnut data={chartData} />
    </div>
  );
};

export default NationalityGroupCucleChart;